// extracted by mini-css-extract-plugin
export default {"Item":"Item_Item__xd9q5","Item--borderBottom":"Item_Item--borderBottom__qIjSF"};